module.exports = __webpack_public_path__ + "img/section2Logo8.8fd64533.png";